import {
  MetricSummaryCard,
  type MetricSummaryCardProps,
} from '../MetricSummaryCard/MetricSummaryCard';

/**
 * Figma `972:20770`. `reach`, relabelled — the corpus carries no per-row author
 * identity, so there is nothing to count distinctly and reach is the audience
 * figure it has. The caveat is real and stays in the tooltip rather than being
 * hidden: summed reach counts a person twice if they saw two mentions.
 */
export function TotalUniqueAudienceCard(props: MetricSummaryCardProps) {
  return (
    <MetricSummaryCard
      {...props}
      copy={{
        title: 'Total unique audience',
        helpText:
          'Shows the number of unique people reached by your brand’s monitored mentions during the selected period. Each person is counted once, even if they saw multiple mentions.',
      }}
    />
  );
}
